<template>
	<JBox>
		<span class="text-gray-900">{{ $t("core.fileName") }}</span>
		<JInputText v-model="form.fileName" class="s-mb-2" />
		<span class="text-gray-900">{{ $t("core.privacyLevel") }}</span>
		<JSelect class="s-mb-3" v-model="form.isPublic" :options="options" />
		<JFlex class="s-justify-between s-mt-3">
			<JButton variant="white" @click="$emit('cancel')">{{ $t("core.cancel") }}</JButton>
			<JButton variant="default-light" @click="onSave">{{ $t("core.update") }}</JButton>
		</JFlex>
	</JBox>
</template>

<script>
export default {
	props: {
		file: {
			type: Object,
			required: true
		}
	},
	computed: {
		options() {
			return [
				{ name: this.$t("core.private"), value: false },
				{ name: this.$t("core.public"), value: true }
			]
		}
	},
	data() {
		return {
			ext: null,
			form: {
				fileName: null,
				isPublic: null
			}
		}
	},

	mounted() {
		const fileName = this.file?.fileName?.split(".")
		this.ext = fileName?.[fileName.length - 1]
		this.form.fileName = fileName?.splice(0, fileName?.length - 1)?.join(".")
		this.form.isPublic = this.file?.isPublic ? true : false
	},

	methods: {
		async onSave() {
			this.$emit("file:updated", {
				...this.form,
				isPublic: this.form.isPublic === "true" ? true : false,
				fileName: this.form.fileName + "." + this.ext
			})
		}
	}
}
</script>
